import { IDeviceStore } from "@formant/core/model/data/IDeviceStore";
import { Uuid } from "@formant/core/model/Uuid";

import { ITeleopSession } from "../teleop/ITeleopSession";
import { TeleopSession } from "../teleop/TeleopSession";
import { IAppStore } from "./IAppStore";
import { IAuthStore } from "./IAuthStore";
import { IDeviceConfigurationStore } from "./IDeviceConfigurationStore";
import { IDeviceDetailsStore } from "./IDeviceDetailsStore";
import { IOrganizationStore } from "./IOrganizationStore";
import { IRouterStore } from "./IRouterStore";
import { IRtcSignalingStore } from "./IRtcSignalingStore";
import { ISignalingStore } from "./ISignalingStore";

export class TeleopSessionStore {
    private cache: Map<Uuid, ITeleopSession> = new Map();

    constructor(
        private appStore: IAppStore,
        private authStore: IAuthStore,
        private deviceConfigurationStore: IDeviceConfigurationStore,
        private deviceDetailsStore: IDeviceDetailsStore,
        private deviceStore: IDeviceStore,
        private organizationStore: IOrganizationStore,
        private routerStore: IRouterStore,
        private rtcSignalingStore: IRtcSignalingStore,
        private signalingStore: ISignalingStore,
    ) {}

    public get(deviceId: Uuid): ITeleopSession | undefined {
        const device = this.deviceStore.get(deviceId);
        if (!device) {
            return undefined;
        }
        let session = this.cache.get(deviceId);

        if (!session) {
            session = new TeleopSession(deviceId, device, {
                appStore: this.appStore,
                authStore: this.authStore,
                deviceConfigurationStore: this.deviceConfigurationStore,
                deviceDetailsStore: this.deviceDetailsStore,
                organizationStore: this.organizationStore,
                routerStore: this.routerStore,
                rtcSignalingStore: this.rtcSignalingStore,
                signalingStore: this.signalingStore,
            });
            this.cache.set(deviceId, session);
        } else {
            TeleopSession.continueSession(session);
        }
        return session;
    }

    public delete(deviceId: Uuid) {
        this.cache.delete(deviceId);
    }
}
